import Layout from '../layouts/MainLayout';
import HeroSection from '../components/HeroSection';
import MultiSlider from '../components/MultiSlider';
export default function Home() {
  return (
    <Layout>

      <HeroSection />

      <MultiSlider />
    </Layout>
  );
}
  